import React, { useState, useEffect } from 'react';
import { FiZap } from 'react-icons/fi';
import KeyboardShortcutsModal from '../modals/KeyboardShortcutsModal';
import { getSearchShortcut } from '../../utils/keyboardUtils';

/**
 * Bouton flottant permanent pour accéder aux raccourcis clavier
 * Affiché en bas à gauche de l'écran
 * Masqué sur mobile et tablette (< 1024px)
 */
const KeyboardShortcutsButton = () => {
    const [showModal, setShowModal] = useState(false);

    // Écoute l'événement global dispatché par le raccourci Ctrl+/ / ⌘+/
    useEffect(() => {
        const handleOpen = () => setShowModal(true);
        window.addEventListener('openKeyboardShortcuts', handleOpen);
        return () => window.removeEventListener('openKeyboardShortcuts', handleOpen);
    }, []);

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className="hidden lg:flex fixed bottom-4 left-4 z-40 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full p-3 shadow-lg transition-all duration-300 hover:scale-110 group"
                title={`Raccourcis clavier (${getSearchShortcut()} pour rechercher)`}
                aria-label="Afficher les raccourcis clavier"
            >
                <FiZap className="h-5 w-5" aria-hidden="true" />
                <span className="absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    Raccourcis clavier
                </span>
            </button>

            <KeyboardShortcutsModal 
                isOpen={showModal} 
                onClose={() => setShowModal(false)} 
            />
        </>
    );
};

export default KeyboardShortcutsButton;
